import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {Link, ProgressBar} from '@primer/react'

import {MilestoneRowMenu} from './MilestoneRowMenu'
import type {MilestoneNode} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

// RELAY-CLEANUP(RepositoryMilestonesInternal): widens nullable fields so the still-Relay parent
// data is assignable. Remove when RepositoryMilestonesInternal leaves Relay.
export type MilestoneRowMetadataFragment = RelayCompat<
  Pick<
    MilestoneNode,
    'id' | 'state' | 'url' | 'repository' | 'progressPercentage' | 'openIssueCount' | 'closedIssueCount' | 'title'
  >
>

type MilestoneRowMetadataProps = {
  milestone: MilestoneRowMetadataFragment
  repositoryNameWithOwner: string
}

export function MilestoneRowMetadata({milestone: data, repositoryNameWithOwner}: MilestoneRowMetadataProps) {
  const getLinkUrl = (state: string) =>
    `/${repositoryNameWithOwner}/issues?q=${encodeURIComponent(`is:${state} milestone:"${data.title ?? ''}"`)}`

  return (
    <div className={styles.listProgressSection}>
      <div className={styles.progress}>
        <ProgressBar
          progress={Math.floor(data.progressPercentage)}
          aria-hidden="true"
          data-testid="milestone-metadata-progress-bar"
          barSize="small"
          className={styles.progressBar}
        />
        <div className={styles.listMetadata}>
          <span>
            <span className={styles.progressPercentage}>{Math.floor(data.progressPercentage)}%</span> complete
          </span>
          <Link className={styles.link} href={getLinkUrl('open')}>
            <span className={styles.progressPercentage}>{data.openIssueCount}</span> open
          </Link>
          <Link className={styles.link} href={getLinkUrl('closed')}>
            <span className={styles.progressPercentage}>{data.closedIssueCount}</span> closed
          </Link>
        </div>
      </div>
      <MilestoneRowMenu milestone={data} />
    </div>
  )
}
